import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import localization from '../../locales/localization';
import { Button, Grid, Segment, Select } from 'semantic-ui-react';
import * as BlagajneDataAccess from '../../data_access/BlagajneDataAccess';
import { bindActionCreators } from 'redux';
import enums from '../../utils/Enums';
import InputField from './InputField';
import RequiredText from './RequiredText';
import NesluzbenaNapomena from './NesluzbenaNapomena';

const styles = {
    container: {
        textAlign: 'center'
    },
    actionButtons: {
        marginTop: 16,
        display: 'flex',
        justifyContent: 'flex-end'
    }
};

const blagajne = [
    {
        id: enums.tipBlagajneRadnje.OTKUPNA,
        naziv: localization.blagajne.uBlagajnuOtkupa
    },
    {
        id: enums.tipBlagajneRadnje.FISKALNA,
        naziv: localization.blagajne.uFiskalnuBlagajnu
    }
];

let capitalize = str => {
    return str[0].toUpperCase() + str.slice(1);
};

class InterniPrijenos extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            blagajna: enums.tipBlagajneRadnje.OTKUPNA,
            iznos: '',
            poslovnicaId: sessionStorage.userRole !== enums.tipKorisnika.DJELATNIK ? this.props.poslovnice[0].id : JSON.parse(sessionStorage.poslovnicaId),
            nesluzbenaNapomena: '',
            nedovoljnoBlagajnaOtkupa: false,
            nedovoljnoFiskalnaBlagajna: false
        };
        this.onChange = this.onChange.bind(this);
        this.provjeriBlagajne = this.provjeriBlagajne.bind(this);
        this.enableUplatiIsplatiButton = this.enableUplatiIsplatiButton.bind(this);
        this.checkKomponenteUplatniceIsplatnice = this.checkKomponenteUplatniceIsplatnice.bind(this);
        this.onNapraviUplatnicuIsplatnicu = this.onNapraviUplatnicuIsplatnicu.bind(this);
    }

    onChange(e, { name, value }) {
        this.setState({ [name]: value }, this.provjeriBlagajne);
    }

    provjeriBlagajne() {
        let nedovoljnoBlagajnaOtkupa = false,
            nedovoljnoFiskalnaBlagajna = false;
        if (this.state.blagajna === enums.tipBlagajneRadnje.OTKUPNA) {
            if (this.state.iznos > this.props.stanjeBlagajni.stanjeFiskBlag) {
                nedovoljnoFiskalnaBlagajna = true;
            }
        } else {
            if (this.state.iznos > this.props.stanjeBlagajni.stanjeBlagOtkupa) {
                nedovoljnoBlagajnaOtkupa = true;
            }
        }
        this.setState(
            {
                nedovoljnoFiskalnaBlagajna: nedovoljnoFiskalnaBlagajna,
                nedovoljnoBlagajnaOtkupa: nedovoljnoBlagajnaOtkupa
            },
            this.enableUplatiIsplatiButton
        );
    }

    enableUplatiIsplatiButton() {
        this.setState({ enableUplatiIsplatiButton: this.checkKomponenteUplatniceIsplatnice() });
    }

    checkKomponenteUplatniceIsplatnice() {
        if (
            !this.state.blagajna ||
            this.state.poslovnicaId === undefined ||
            !this.state.iznos ||
            !this.state.nesluzbenaNapomena ||
            this.state.nedovoljnoFiskalnaBlagajna ||
            this.state.nedovoljnoBlagajnaOtkupa
        ) {
            return false;
        }
        return true;
    }

    onNapraviUplatnicuIsplatnicu() {
        let uplatnicaIsplatnica = {
            iznos: parseFloat(this.state.iznos),
            poslovnicaId: this.state.poslovnicaId,
            tipOdredisneBlagajne: this.state.blagajna,
            napomena: this.state.nesluzbenaNapomena
        };
        this.props.blagajneDataAccess.interniPrijenosUBlagajnu(uplatnicaIsplatnica, this.props.closeModal);
    }

    render() {
        return (
            <div style={styles.container}>
                <Segment>
                    <Grid stackable>
                        {sessionStorage.userRole !== enums.tipKorisnika.DJELATNIK ? (
                            <Grid.Row>
                                <Grid.Column verticalAlign="middle">
                                    <Select
                                        label={localization.blagajne.poslovnica}
                                        options={this.props.poslovnice.map(p => {
                                            return { key: p.id, text: p.naziv, value: p.id };
                                        })}
                                        name="poslovnicaId"
                                        onChange={this.onChange}
                                        value={this.state.poslovnicaId}
                                        compact
                                        required
                                        search
                                    />
                                </Grid.Column>
                            </Grid.Row>
                        ) : null}
                        <Grid.Row columns={3}>
                            <Grid.Column verticalAlign="middle">
                                <p>
                                    {this.state.blagajna === enums.tipBlagajneRadnje.OTKUPNA
                                        ? capitalize(localization.blagajne.izFiskalneBlagajne)
                                        : capitalize(localization.blagajne.izBlagajneOtkupa)}
                                </p>
                            </Grid.Column>
                            <Grid.Column textAlign="left" verticalAlign="middle">
                                <Select
                                    options={blagajne.map(b => {
                                        return { key: b.id, text: b.naziv, value: b.id };
                                    })}
                                    name="blagajna"
                                    onChange={this.onChange}
                                    value={this.state.blagajna}
                                    compact
                                    required
                                    search
                                />
                            </Grid.Column>
                            <Grid.Column verticalAlign="middle">
                                <InputField
                                    label={localization.common.eur}
                                    placeholder={localization.blagajne.iznos}
                                    name="iznos"
                                    value={this.state.iznos}
                                    onChange={this.onChange}
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>
                <NesluzbenaNapomena
                    onChangeNapomena={this.onChange}
                    placeholder={localization.common.nesluzbenaNapomena}
                    required={!this.state.nesluzbenaNapomena}
                    requiredText={localization.blagajne.interniPrijenosObveznaNesluzbenaNapomena}
                />
                <div style={styles.actionButtons}>
                    <Button icon="close" content={localization.common.odustani} onClick={this.props.closeModal} />
                    <Button
                        icon="money"
                        color="green"
                        disabled={!this.state.enableUplatiIsplatiButton}
                        content={localization.blagajne.napraviPrijenos}
                        onClick={this.onNapraviUplatnicuIsplatnicu}
                    />
                </div>
                {this.state.nedovoljnoFiskalnaBlagajna ? (
                    <div style={styles.actionButtons}>
                        <RequiredText requiredText={localization.common.nedovoljnoNovcaFiskalnaBlagajna} />
                    </div>
                ) : this.state.nedovoljnoBlagajnaOtkupa ? (
                    <div style={styles.actionButtons}>
                        <RequiredText requiredText={localization.common.nedovoljnoNovcaBlagajnaOtkupa} />
                    </div>
                ) : null}
            </div>
        );
    }
}

InterniPrijenos.propTypes = {
    stanjeBlagajni: PropTypes.object.isRequired,
    poslovnice: PropTypes.array.isRequired,
    blagajneDataAccess: PropTypes.object.isRequired,
    closeModal: PropTypes.func.isRequired
};

let mapStateToProps = function(state, ownProps) {
    return {
        stanjeBlagajni: state.blagajneReducer.stanje,
        poslovnice: state.mjestaReducer.poslovnice || []
    };
};

let mapDispatchToProps = function(dispatch) {
    return {
        blagajneDataAccess: bindActionCreators(BlagajneDataAccess, dispatch)
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InterniPrijenos);
